import { ReactNode } from 'react';
import { createUseStyles } from 'react-jss';
import { IonSegmentCustomEvent } from '@ionic/core';
import { IonSegment, SegmentChangeEventDetail } from '@ionic/react';

const useStyles = createUseStyles({
    segment: {
        '& ion-segment-button::part(indicator-background)': {
            background: 'var(--ion-color-primary)'
        },

        '& ion-segment-button.segment-button-checked::part(native)': {
            color: 'white'
        }
    }
});

export type ISegmentProps<T extends string> = {
    children: ReactNode;
    value?: T;
    'data-id'?: string;
    onChange?: (value: T) => void;
};

export const IOSTabs = <T extends string>({ children, value, 'data-id': dataId, onChange }: ISegmentProps<T>) => {
    const classes = useStyles();

    const handleChange = (e: IonSegmentCustomEvent<SegmentChangeEventDetail>) => {
        if (onChange) {
            onChange(e.detail.value as T);
        }
    };

    return (
        <IonSegment
            mode="ios"
            data-id={dataId}
            value={value}
            className={classes.segment}
            onIonChange={handleChange}
        >
            {children}
        </IonSegment>
    );
};
